export enum CmsPageContentIdentifier {
  Compendium = 'Compendium',
  Title = 'Title',
  Intro = 'Intro',
  Instructions = 'Instructions',
  Faq = 'Faq',
  FormFieldRequiredHint = 'FormFieldRequiredHint',
  FormFieldPlaceholderZipCode = 'FormFieldPlaceholderZipCode',
  FormFieldPlaceholderCity = 'FormFieldPlaceholderCity',
  FormFieldPlaceholderStreet = 'FormFieldPlaceholderStreet',
  FormFieldPlaceholderHouseNumber = 'FormFieldPlaceholderHouseNumber',
  FormFieldErrorMessageZipCodeRequired = 'FormFieldErrorMessageZipCodeRequired',
  FormFieldErrorMessageZipCodeInvalid = 'FormFieldErrorMessageZipCodeInvalid',
  FormFieldErrorMessageCityRequired = 'FormFieldErrorMessageCityRequired',
  FormFieldErrorMessageStreetRequired = 'FormFieldErrorMessageStreetRequired',
  FormFieldErrorMessageHouseNumberRequired = 'FormFieldErrorMessageHouseNumberRequired',
  FormFieldErrorMessageHouseNumberInvalid = 'FormFieldErrorMessageHouseNumberInvalid',
  CheckButton = 'CheckButton',
  LoadingOverlayTitle = 'LoadingOverlayTitle',
  LoadingOverlayMessage = 'LoadingOverlayMessage',
  ErrorMessageServerError = 'ErrorMessageServerError',
  ErrorMessageNoMatchingAddress = 'ErrorMessageNoMatchingAddress',
  ErrorMessageNoTariffOffers = 'ErrorMessageNoTariffOffers',
  SuccessMessageAvailableDslOnly = 'SuccessMessageAvailableDslOnly',
  SuccessMessageAvailableFmsOnly = 'SuccessMessageAvailableFmsOnly',
  SuccessMessageAvailableAll = 'SuccessMessageAvailableAll',
  InfoMessageCorrectedAddress = 'InfoMessageCorrectedAddress',
  CheckOtherAddressLink = 'CheckOtherAddressLink',
  TargetGroupSwitcherLabel = 'TargetGroupSwitcherLabel',
  TargetGroupNamePrivatkunden = 'TargetGroupNamePrivatkunden',
  TargetGroupNamePrivatkundenInfo = 'TargetGroupNamePrivatkundenInfo',
  TargetGroupNameStudenten = 'TargetGroupNameStudenten',
  TargetGroupNameStudentenInfo = 'TargetGroupNameStudentenInfo',
  TargetGroupNameSebstaendige = 'TargetGroupNameSebstaendige',
  TargetGroupNameSebstaendigeInfo = 'TargetGroupNameSebstaendigeInfo',
  TargetGroupNameBestandskunden = 'TargetGroupNameBestandskunden',
  TargetGroupNameBestandskundenInfo = 'TargetGroupNameBestandskundenInfo',
  TargetGroupNameSonderbuchungen = 'TargetGroupNameSonderbuchungen',
  ContractDuration1Month = 'ContractDuration1Month',
  ContractDuration24Month = 'ContractDuration24Month',
  ContractDurationSwitcherLabel = 'ContractDurationSwitcherLabel',
  AvailableAsLabel = 'AvailableAsLabel',
  GlassfaserModalHeader = 'GlassfaserModalHeader',
  GlassfaserModalFtthAdditionalText = 'GlassfaserModalFtthAdditionalText',
  GlassfaserModalDoseIllustrationText = 'GlassfaserModalDoseIllustrationText',
  GlassfaserModalAvailabilityRadioText = 'GlassfaserModalAvailabilityRadioText',
  GlassfaserModalBuildingPartId = 'GlassfaserModalBuildingPartId',
  GlassfaserModalAertMessage = 'GlassfaserModalAertMessage',
  CoaxOptionLabel = 'CoaxOptionLabel',
  DslOptionLabel = 'DslOptionLabel',
  FmsOptionLabel = 'FmsOptionLabel',
  TariffButton = 'TariffButton',
  TechnologySelectionButton = 'TechnologySelectionButton',
  NoTariffForSelection = 'NoTariffForSelection',
  TariffCatalogDescription = 'TariffCatalogDescription',
  PriceHint = 'PriceHint',
  ContinueWithSelectedTariffButton = 'ContinueWithSelectedTariffButton',
  ContinueWithOtherTariffButton = 'ContinueWithOtherTariffButton',
  UpSellHint = 'UpSellHint',
  AlternativeHint = 'AlternativeHint',
  MessageSelectedAvailable = 'MessageSelectedAvailable',
  MessageSelectedNotAvailable = 'MessageSelectedNotAvailable',
  TariffRecommendation = 'TariffRecommendation',
  TariffProductTypeHintDSL = 'TariffProductTypeHintDSL',
  TariffProductTypeHintFMS = 'TariffProductTypeHintFMS',
  SuccessMessageMaxBandwidth = 'SuccessMessageMaxBandwidth',
  SuccessMessageTitle = 'SuccessMessageTitle',
  SuccessMessageBandwidthTitle = 'SuccessMessageBandwidthTitle',
  SuccessMessageMaxBandwidthAddress = 'SuccessMessageMaxBandwidthAddress',
  SuccessMessageModalHeader = 'SuccessMessageModalHeader',
  SuccessMessageModalContent = 'SuccessMessageModalContent',
  SuccessMessageModalContentInList = 'SuccessMessageModalContentInList',
  MaxBandwidthCoaxInList = 'MaxBandwidthCoaxInList',
  MaxBandwidthCoax = 'MaxBandwidthCoax',
  MaxBandwidthDslInList = 'MaxBandwidthDslInList',
  MaxBandwidthDsl = 'MaxBandwidthDsl',
  MaxBandwidthHomeSpot4GInList = 'MaxBandwidthHomeSpot4GInList',
  MaxBandwidthHomeSpot4G = 'MaxBandwidthHomeSpot4G',
  MaxBandwidthHomeSpot5GInList = 'MaxBandwidthHomeSpot5GInList',
  MaxBandwidthHomeSpot5G = 'MaxBandwidthHomeSpot5G',
  MaxBandwidthFtthInList = 'MaxBandwidthFtthInList',
  MaxBandwidthFtth = 'MaxBandwidthFtth',
  UpsellLabel = 'UpsellLabel',
  DownsellLabel = 'DownsellLabel',
  SelectedBandwidthMatchLabel = 'SelectedBandwidthMatchLabel',
  AvailableTechnologiesSubheader = 'AvailableTechnologiesSubheader',
  DslTechnologyLabel = 'DslTechnologyLabel',
  DslTechnologyDescription = 'DslTechnologyDescription',
  FmsTechnologyLabel = 'FmsTechnologyLabel',
  FmsTechnologyDescription = 'FmsTechnologyDescription',
  CoaxTechnologyLabel = 'CoaxTechnologyLabel',
  CoaxTechnologyDescription = 'CoaxTechnologyDescription',
  FtthTechnologyLabel = 'FtthTechnologyLabel',
  FtthTechnologyDescription = 'FtthTechnologyDescription',
  FtthTechnologyInfoHeader = 'FtthTechnologyInfoHeader',
  FtthTechnologyInfoDescription = 'FtthTechnologyInfoDescription',
  FtthEarliestAvailabilityDateModal = 'FtthEarliestAvailabilityDateModal',
  ModalFooterHeadline = 'ModalFooterHeadline',
  ModalFooterSubheader = 'ModalFooterSubheader',
  ModalFooterIcon = 'ModalFooterIcon',
  ModalFooterDescription = 'ModalFooterDescription',
  FmsTechnologyInfoDescription = 'FmsTechnologyInfoDescription',
  DslTechnologyInfoDescription = 'DslTechnologyInfoDescription',
  CoaxTechnologyInfoDescription = 'CoaxTechnologyInfoDescription',
  FmsTechnologyInfoHeader = 'FmsTechnologyInfoHeader',
  DslTechnologyInfoHeader = 'DslTechnologyInfoHeader',
  CoaxTechnologyInfoHeader = 'CoaxTechnologyInfoHeader',
  HomeAvailabilityCheckButtonText = 'HomeAvailabilityCheckButtonText',
  HouseholdConfiguratorHeadline = 'HouseholdConfiguratorHeadline',
  HouseholdConfiguratorIntroText = 'HouseholdConfiguratorIntroText',
  HouseholdConfiguratorSwitcherNoInfo = 'HouseholdConfiguratorSwitcherNoInfo',
  HouseholdConfiguratorUsageText = 'HouseholdConfiguratorUsageText',
  HouseholdConfiguratorUsageFirstCheckbox = 'HouseholdConfiguratorUsageFirstCheckbox',
  HouseholdConfiguratorUsageSecondCheckbox = 'HouseholdConfiguratorUsageSecondCheckbox',
  HouseholdConfiguratorUsageThirdCheckbox = 'HouseholdConfiguratorUsageThirdCheckbox',
  FtthEarliestAvailabilityDate = 'FtthEarliestAvailabilityDate',
  FtthEarliestAvailabilityVmOngoingDate = 'FtthEarliestAvailabilityVmOngoingDate',
  FtthBeforePreparedEarliestAvailabilityDate = 'FtthBeforePreparedEarliestAvailabilityDate',
  TechnologyPricingDiscountLabel = 'TechnologyPricingDiscountLabel',
  TechnologyPricingSurchargeLabel = 'TechnologyPricingSurchargeLabel',
  TechnologyPricingMonthlyList = 'TechnologyPricingMonthlyList',
  TechnologyPricingProductVariationHint = 'TechnologyPricingProductVariationHint',
  TechnologyPricingProductVariations = 'TechnologyPricingProductVariations',
  TechnologyPricingNonRecurringChargesLabel = 'TechnologyPricingNonRecurringChargesLabel',
  TechnologyPricingPriceVariationHintLabel = 'TechnologyPricingPriceVariationHintLabel',
  CoaxTechnologyGlyphicon = 'CoaxTechnologyGlyphicon',
  CoaxTechnologyGlyphiconSolid = 'CoaxTechnologyGlyphiconSolid',
  DslTechnologyGlyphicon = 'DslTechnologyGlyphicon',
  DslTechnologyGlyphiconSolid = 'DslTechnologyGlyphiconSolid',
  FmsTechnologyGlyphicon = 'FmsTechnologyGlyphicon',
  FmsTechnologyGlyphiconSolid = 'FmsTechnologyGlyphiconSolid',
  FtthTechnologyGlyphicon = 'FtthTechnologyGlyphicon',
  FtthTechnologyGlyphiconSolid = 'FtthTechnologyGlyphiconSolid',
  GlyphiconTaaKabel = 'GlyphiconTaaKabel',
  GlyphiconTaaKabelSolid = 'GlyphiconTaaKabelSolid',
  GlyphiconTaaDSL = 'GlyphiconTaaDSL',
  GlyphiconTaaDSLSolid = 'GlyphiconTaaDSLSolid',
  GlyphiconTaaLTE = 'GlyphiconTaaLTE',
  GlyphiconTaaLTESolid = 'GlyphiconTaaLTESolid',
  GlyphiconTaaGlasfaser = 'GlyphiconTaaGlasfaser',
  GlyphiconTaaGlasfaserSolid = 'GlyphiconTaaGlasfaserSolid',
  HighlightedTechnologyDisturber = 'HighlightedTechnologyDisturber',
  HighlightedTechnologyDisturberCCI = 'HighlightedTechnologyDisturberCCI',
  TechnologyPricingInfrastructureCharge = 'TechnologyPricingInfrastructureCharge',
  TechnologyPricingDevelopmentCharge = 'TechnologyPricingDevelopmentCharge',
  TechnologyPricingOneTimeMonthlyDiscount = 'TechnologyPricingOneTimeMonthlyDiscount',
  TechnologyPricingConnectionDiscount = 'TechnologyPricingConnectionDiscount',
  TechnologyPricingDevelopmentDisount = 'TechnologyPricingDevelopmentDisount',
  ActivationCostInfoDescription = 'ActivationCostInfoDescription',
  DevelopmentCostInfoDescription = 'DevelopmentCostInfoDescription',
  TileSliderColumns = 'TileSliderColumns',
  TargetGroupNamePrivatkundenInfoIcon = 'TargetGroupNamePrivatkundenInfoIcon',
  TargetGroupNameStudentenInfoIcon = 'TargetGroupNameStudentenInfoIcon',
  TargetGroupNameSebstaendigeInfoIcon = 'TargetGroupNameSebstaendigeInfoIcon',
  TargetGroupNameBestandskundenInfoIcon = 'TargetGroupNameBestandskundenInfoIcon',
  DslTechnologyInfoLabel = 'DslTechnologyInfoLabel',
  KabelTechnologyInfoLabel = 'KabelTechnologyInfoLabel',
  FmsTechnologyInfoLabel = 'FmsTechnologyInfoLabel',
  FtthTechnologyInfoLabel = 'FtthTechnologyInfoLabel',
  GlassfaserModalRadioButtonTextNo = 'GlassfaserModalRadioButtonTextNo',
  GlassfaserModalRadioButtonTextYes = 'GlassfaserModalRadioButtonTextYes',
  GlassfaserModalRadioButtonValdation = 'GlassfaserModalRadioButtonValdation',
  GlassfaserModalFtthEnhancementAdditionalText = 'GlassfaserModalFtthEnhancementAdditionalText',
  BuildingPartValidationError = 'BuildingPartValidationError',
  DtagFtthLoadingOverlayTitle = 'DtagFtthLoadingOverlayTitle',
  FormFieldPlaceholderHouseNumberMobileView = 'FormFieldPlaceholderHouseNumberMobileView',
  FtthMaxBandwidthEnhancementText = 'FtthMaxBandwidthEnhancementText',
  monthlyPriceStart = 'monthlyPriceStart',
  monthlyPriceStartMin =  'monthlyPriceStartMin',
  monthlyPriceStartPermanent = 'monthlyPriceStartPermanent',
  monthlyPriceStartPermanentMin = 'monthlyPriceStartPermanentMin',
  monthlyPriceNext = 'monthlyPriceNext',
  combiBenefit = 'combiBenefit',
  initialFees = 'initialFees',
  initialFeesMin = 'initialFeesMin',
  installationFee = 'installationFee',
  installationFeeStrike = 'installationFeeStrike',
  developmentFeeDefault = 'developmentFeeDefault',
  developmentFeeActual = 'developmentFeeActual',
  developmentFeeDefaultStrike = 'developmentFeeDefaultStrike',
  developmentFeeActualStrike = 'developmentFeeActualStrike',
  developmentFeeDefaultInfo = 'developmentFeeDefaultInfo',
  developmentFeeActualStrikeInfo = 'developmentFeeActualStrikeInfo',
  developmentFeeActualInfo = 'developmentFeeActualInfo',
  developmentFeeDefaultStrikeInfo = 'developmentFeeDefaultStrikeInfo',
  installationFeeInfo = 'installationFeeInfo',
  installationFeeStrikeInfo = 'installationFeeStrikeInfo',
  FtthExpectedExpansionText = 'FtthExpectedExpansionText',
  ExpectedExpansionDateText = 'ExpectedExpansionDateText',
  FtthFreeConversionServiceText = 'FtthFreeConversionServiceText',
  ComboBenefitInfo = 'ComboBenefitInfo',
  DevelopmentPrinceInfoText = 'DevelopmentPrinceInfoText',
  FtthAvailabilityModalFooterInfo = 'FtthAvailabilityModalFooterInfo',
  HomeAvailabilityModalContactInfo = 'HomeAvailabilityModalContactInfo',
  HomeAvailabilityModalContactDiscription = 'HomeAvailabilityModalContactDiscription',
  FtthDevelopmentInfoText = 'FtthDevelopmentInfoText',
  FtthAlertBoxText = 'FtthAlertBoxText',
  OcclDevelopmentPrinceInfoText = 'OcclDevelopmentPrinceInfoText'
}

export interface ActionType {
  type: string,
  value: any,
}

export interface ReduxStateType {
  cmsContent: CmsPageContentType,
  address: AddressType,
  householdConfig: HouseholdConfigurationType,
  result?: ResultType,
  resultError: boolean,
  cityList?: string[],
  streetList?: string[],
  meta: AvailabilityCheckMetaType,
  enabledFeatures: Feature[],
  filterValues: FilterValuesType,
  trackingInfo?:TrackingInfoType,
}

export type TrackingInfoType = {
  isFirstSliderView : boolean;
  sliderTariffPositions : TariffPositionsType;
};

export type TariffPositionsType = {
  [key:string]: number;
};

export type FilterValuesType = {
  [key in FilterCriteriaType]: any;
};

export type CmsPageContentType = {
  [key: string]: string
};

export interface AddressType {
  zipCode: string,
  city: string,
  houseNumber: string,
  street: string,
  corrected: boolean,
  buildingParts: TechBuildingPart[]
}

export interface TechBuildingPart {

  buildingPartId: string;

  buildingPartName: string;

  expansionPeriodEnd: string;

  expansionPeriodStart: string;

  expansionStatus: string;

}

export interface ResultType {
  address: AddressType,
  tariffOffers: TariffOfferType[]
  maxBandwidth: BandwidthDisplayType,
  maxBandwidthForAccessTechnology: Map<AccessTechnologyKey, BandwidthDisplayType>,
  ecommerceProductValues: EcommerceProductValue[],
  householdConfiguration: HouseholdConfigurationType,
  currentContractDuration?: number,
  overviewDisplayPrices: OverviewDisplayPrices[],
  isCmsCall: boolean
}

export interface OverviewDisplayPrices {
  tariffVariations: string[],
  tariffDisplayPrice: TariffDisplayPrice
}

export interface TariffDisplayPrice {
  displayContext: DisplayContext,
  monthlyPrice: PriceCategoryWithRanks,
  nextPriceChargeDataList: NextPriceChargesType[],
  priceCategoryWithRankDataList: PriceCategoryWithRanks[]
}

export enum DisplayContext {
  AV_CHECK_RESULT = 'AV_CHECK_RESULT',
  AV_CHECK_TECHNOLOGY_SELECTION_OVERLAY = 'AV_CHECK_TECHNOLOGY_SELECTION_OVERLAY',
}

export interface HouseholdConfigurationType {
  personInHousehold: number,
  usageTypes: UsageType[],
}

export interface BandwidthDisplayType {
  value: number,
  text: string,
  unit: BandwidthUnit,
}

export interface AvailabilityCheckMetaType {
  cciTheme: boolean,
  selectedBandwidth?: BandwidthDisplayType,
  defaultTargetGroup: TargetGroup,
  heroOfferData?: HeroOfferData
}

export interface AvailabilityCheckPageValueType {
  meta: AvailabilityCheckMetaType,
  enabledFeatures: Feature[],
  cmsContent: CmsPageContentType,
  address?: AddressType,
  index: IndexType,
}

export enum IndexType {
  INITIAL = 'INITIAL',
  NO_OFFER = 'NO_OFFER',
  ERROR = 'ERROR',
}

export interface TariffOfferType {
  offerName: string,
  tariffVariationCode: string,
  type: ProductType,
  accessTechnology: FixedLineAccessTechnologyType,
  accessTechnologyPriority: number
  targetGroup: TargetGroup,
  contractDuration: number,
  url: string,
  charges: ChargesType,
  technicalRank: number,
  simOnly: boolean,
  highlightProduct: boolean,
  highlightTechnology: boolean,
  offerType?: OfferType,
  externalId?: string,
  alternateTo?: string,
  specialReservation: boolean,
  cmsTariffDescription: CmsTariffDescriptionType,
  earliestActivationDate?: string,
  technologyAvailability: TechnologyAvailability,
  commissions: Commission[],
  accessType: string,
  tariffUploadBandWidth : string
}

export interface CmsTariffDescriptionType {
  name: CmsTariffContentType,
  shortName: CmsTariffContentType,
  downloadBandwidthWithIcon: CmsTariffContentType,
  downloadBandwidthText: CmsTariffContentType,
  downloadBandwidthUnit: CmsTariffContentType,
  features: CmsTariffContentType[],
  featuresShort: CmsTariffContentType[],
  uploadBandwidth: CmsTariffContentType,
  pibLink: CmsTariffContentType,
  accessTechnologyDescription: CmsTariffContentType
}

export interface CmsDebugInfoType {
  url: string,
}

export interface CmsTariffContentType {
  content: string,
  debugInfo?: CmsDebugInfoType,
  rendered: string,
}

export enum Feature {
  TARO_COMMISSIONS = 'TARO_COMMISSIONS',
  TARO_COMMISSIONS_CCI = 'TARO_COMMISSIONS_CCI',
  TECHNOLOGY_PRICING = 'TECHNOLOGY_PRICING',
  BAKU = 'BAKU',
  FTTH = 'FTTH',
  UNIFIED_TRACKING = 'UNIFIED_TRACKING',
  TARO_PRICING_PROMOTION = 'TARO_PRICING_PROMOTION',
  DTAG_FTTH_WEBSHOP = 'DTAG_FTTH_WEBSHOP',
  DTAG_FTTH_CCI = 'DTAG_FTTH_CCI',
  DTAG_GENERAL = 'DTAG_GENERAL',
  DTAG_GUI_ENHANCEMENTS = 'DTAG_GUI_ENHANCEMENTS',
  DTAG_GUI_ENHANCEMENTS_CCI = 'DTAG_GUI_ENHANCEMENTS_CCI',
  AVCHECK_FLOAT_LABELS = 'AVCHECK_FLOAT_LABELS',
  TARO_DISPLAY_PRICES_CCI = 'TARO_DISPLAY_PRICES_CCI',
  TARO_DISPLAY_PRICES = 'TARO_DISPLAY_PRICES',
  DISPLAY_TARIFF_SHORT_NAME = 'DISPLAY_TARIFF_SHORT_NAME',
}

export enum BandwidthUnit {
  KILOBIT_PER_SECOND = 'KILOBIT_PER_SECOND',
  MEGABIT_PER_SECOND = 'MEGABIT_PER_SECOND',
  GIGABIT_PER_SECOND = 'GIGABIT_PER_SECOND',
}

export enum OfferType {
  SELECTED = 'SELECTED',
  UPSELL = 'UPSELL',
  DOWNSELL = 'DOWNSELL',
}

export enum TargetGroup {
  PRIVATKUNDEN = 'PRIVATKUNDEN',
  STUDENTEN = 'STUDENTEN',
  SELBSTAENDIGE = 'SELBSTAENDIGE',
  BESTANDSKUNDEN = 'BESTANDSKUNDEN',
}

export enum FilterCriteriaType {
  TARGET_GROUP = 'TARGET_GROUP',
  CONTRACT_DURATION = 'CONTRACT_DURATION',
  SPECIAL_RESERVATION = 'SPECIAL_RESERVATION',
}

export enum ProductType {
  DSL = 'DSL',
  FMS = 'FMS',
}

export enum FixedLineAccessTechnologyType {
  DSL = 'DSL',
  COAX = 'COAX',
  FMS = 'FMS',
  FTTH = 'FTTH',
}

export enum AccessTechnologyKey {
  DSL = 'DSL',
  COAX = 'COAX',
  FMS_4G = 'FMS_4G',
  FMS_5G = 'FMS_5G',
  FTTH = 'FTTH',
}

export enum ChargeCategory {
  BASE_CHARGE = 'BASE_CHARGE',
  TECHNOLOGY_CHARGE = 'TECHNOLOGY_CHARGE',
}

export type ChargeDetails = {
  [key in ChargeCategory]: number;
};

export interface ChargesType {
  recurringCosts: number,
  recurringDetails: ChargeDetails,
  activationFee: number,
  shippingCosts: number,
  developmentCosts: number,
  nonRecurringCosts: number,
  nextPriceCharges: NextPriceChargesType[],
  nonRecurringDetails: ChargeDetails,
  priceCategoryWithRanks : PriceCategoryWithRanks[],
  tariffDisplayPrice?: TariffDisplayPrice
}

export interface PriceItemRanks {
  serviceItemCode: string,
  rank: number,
}

export interface PriceCategoryWithRanks {
  priceItemRank: number,
  category: Category,
  value: number,
  itemId: string,
  maxValue: number
}

export enum Category {
  ACTIVATION_FEE_CHARGE = 'ACTIVATION_FEE_CHARGE',
  ACTIVATION_FEE_DISCOUNT = 'ACTIVATION_FEE_DISCOUNT',
  DEVELOPMENT_COST_CHARGE = 'DEVELOPMENT_COST_CHARGE',
  DEVELOPMENT_COST_DISCOUNT = 'DEVELOPMENT_COST_DISCOUNT',
  INFRASTRUCTURE_FEE_CHARGE = 'INFRASTRUCTURE_FEE_CHARGE',
  ONETIME_MONTHLY_CHARGE = 'ONETIME_MONTHLY_CHARGE',
  ONETIME_MONTHLY_DISCOUNT = 'ONETIME_MONTHLY_DISCOUNT',
  UNSUPPORTED = 'UNSUPPORTED',
  INITIAL = 'INITIAL',
  MONTHLY = 'MONTHLY',
}

export interface DisplayConfig {
  priceItemRank: number,
  itemId: string,
}

export interface NextPriceChargesType {
  recurringCosts: number,
  startingMonth: number,
}

export interface SelectorOptionType {
  label: string,
  value: string,
  rank: number,
}

export interface TariffCatalogType {
  dslTariffOffer: TariffOfferType | undefined,
  coaxTariffOffer: TariffOfferType | undefined,
  fmsTariffOffer: TariffOfferType | undefined,
  ftthTariffOffer: TariffOfferType | undefined,
}

export interface EcommerceProductValue {
  name: string,
  attributes: any,
}

export enum UsageType {
  STREAMING = 'STREAMING',
  HOME_OFFICE = 'HOME_OFFICE',
  GAMING = 'GAMING',
}

export interface AvCheckFormData {
  zipCode: string,
  city: string,
  houseNumber: string,
  street: string,
  corrected: boolean,
  numberOfPersons: string,
  usageTypeOnlineGaming: boolean,
  usageTypeVideoStreaming: boolean,
  usageTypeHomeOffice: boolean,
  buildingParts: TechBuildingPart,
  isFiberExtensionAvailable?: boolean,
  buildingPartId?: string,
  tariffVariationCode?: string,
  accessType?: string,
}

export interface HeroOfferData {
  manufacturerHeroOffer?: string,
  hardwareGroupNameHeroOffer?: string,
  byshColor?: string,
  byshStorageSize?: number,
  byshVertragsart?: string,
  byshRatenzahlung?: number,
}

export interface TechnologyAvailability {
  expansionStatus: string,
  expansionPeriodStart: string,
  expansionPeriodEnd: string,
  homeIdPossible: boolean,
}

export interface Commission {
  commissionId: string
}

export class AvCheckRequestBody {
  address: AddressType;

  personInHousehold: string;

  usageTypes: UsageType[];

  isFiberExtensionAvailable?: boolean;

  buildingPartId?: string;

  heroOfferData?: HeroOfferData;

  tariffVariationCode?: string;

  accessType?: string;

  constructor(formData: AvCheckFormData, heroOfferData?: HeroOfferData) {
    this.address = {
      city: formData.city,
      street: formData.street,
      zipCode: formData.zipCode,
      houseNumber: formData.houseNumber,
      corrected: formData.corrected,
      buildingParts: [formData.buildingParts],
    };
    this.personInHousehold = formData.numberOfPersons === 'no-selection' ? '' : formData.numberOfPersons;
    this.usageTypes = [
      ...(formData.usageTypeVideoStreaming ? [UsageType.STREAMING] : []),
      ...(formData.usageTypeHomeOffice ? [UsageType.HOME_OFFICE] : []),
      ...(formData.usageTypeOnlineGaming ? [UsageType.GAMING] : []),
    ];
    this.isFiberExtensionAvailable = formData.isFiberExtensionAvailable;
    this.buildingPartId = formData.buildingPartId;
    this.heroOfferData = heroOfferData;
    this.tariffVariationCode = formData.tariffVariationCode;
    this.accessType = formData.accessType;
  }
}
